import React from 'react';
import { formatLabel } from 'utils/helpers';
import { hasContent, renderPrecautions, renderArray } from './utils';

const ReactivitySection = ({ chemicalDetails }) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 transition-all duration-300 hover:shadow-xl">
      <h2 className="text-2xl font-bold mb-6">
        <i className="fas fa-flask mr-2"></i>Reactivity & Stability Information
      </h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {chemicalDetails.reactivity_and_stability && Object.entries(chemicalDetails.reactivity_and_stability).map(([key, value]) => (
          hasContent(value) && (
            <div key={key} className={`rounded-lg p-6 shadow border bg-gray-50 ${key === 'hazards' ? 'border-red-500 bg-red-100' : ''}`}>
              <div className="font-bold text-lg mb-2">{formatLabel(key)}</div>
              <div>{(key === 'precautions' || key === 'hazards' || key === 'reactivity') ? renderPrecautions(value, key === 'hazards') : renderArray(value)}</div>
            </div>
          )
        ))}
      </div>
    </div>
  );
};

export default ReactivitySection;
